export default "__VITE_ASSET__Doh$fgYO__"